import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {getDepartmentIncidents, closeOverlay, getRisk } from "../../store/actions/riskActions";
import {getIncidentsCompliance, getIncidentsDepartment, getIncident, closeIncident} from "../../store/actions/incidentActions"
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import IncidentDetailsForm from "../Incidents/IncidentOverlay";

const IncidentList = ({
  activeDepartmentId,
  activeDepartment,
  getIncidentFN,
  getDepartmentIncidents,
  department_incidents,
  getIncidentsFN,
  getIncidentsComplianceFN,
  closeOverlayFN,
  getRiskFN,
  closeIncidentFN,
  isCompliance
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [IncidentList, setIncidentList] = useState([]);

  useEffect(() => {
    if (activeDepartmentId && isCompliance !== true) {
      //getDepartmentIncidents(activeDepartmentId);
      getIncidentsFN(activeDepartmentId)
    } else if (activeDepartmentId && isCompliance === true){
      getIncidentsComplianceFN(activeDepartmentId)
    }
  }, [activeDepartmentId, getDepartmentIncidents]);


  useEffect(() => {
    if (department_incidents) {
     setIncidentList(department_incidents)
    }
  }, [department_incidents]);

  const openPopup = (incident) => {

    setSelectedIncident(incident);
    getIncidentFN(incident.incident_id)
    getRiskFN(incident.risk_id)
    setIsPopupOpen(true);
  };

  const closePopup = async () => {
    console.log("Closed")
    setIsPopupOpen(false);
    closeOverlayFN();
    closeIncidentFN();
    if (isCompliance !== true) {
      await getIncidentsFN(activeDepartmentId);
    } else if (isCompliance === true){
      await getIncidentsComplianceFN(activeDepartmentId)
    }
  };

  const getBarColor = (value) => {
    if (value >= 75) return '#00AFB9'; // Green for high values
    if (value >= 50) return '#FFD166'; // Yellow for medium values
    if (value > 0) return '#EF476F'; // Red for low values
    return '#f07167'; // Default background color for 0
  };


  return (
    <div className="mt-6 p-16 pt-4 bg-white rounded ">
      {IncidentList?.length ? (
        <div className="overflow-x-auto rounded-lg [box-shadow:0_4px_6px_-1px_rgba(0,0,0,0.1)]">
          <table className="min-w-full table-fixed text-sm text-left text-gray-700 border-collapse bg-transparent">
            <colgroup>
              <col style={{ width: '2rem' }} />   {/* Incident ID */}
              <col style={{ width: '8rem' }} />   {/* Risk Owner */}
              <col style={{ width: '16rem' }} />  {/* Risk */}
              <col style={{ width: '6rem' }} />  {/* Control Efficiency */}
              <col style={{ width: '10rem' }} />  {/* Created At */}
              <col style={{ width: '8rem' }} />   {/* Status */}
              <col style={{ width: '10rem' }} />  {/* Closed At */}
            </colgroup>

            <thead className="bg-gray-100">
              <tr>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Incident ID</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Risk Owner</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Risk</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Control Efficiency</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Created At</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Status</th>
                <th className="px-2 py-2 border-b text-xs truncate whitespace-nowrap overflow-hidden">Closed At</th>
              </tr>
            </thead>

            <tbody>
              {IncidentList.map((incident) => (
                <tr
                  key={incident.incident_id}
                  className="hover:bg-[#F8F8F8] transition-colors duration-200 cursor-pointer"
                  onClick={() => openPopup(incident)}
                >
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    {incident.incident_id}
                  </td>
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    {incident.risk_owner_name || "N/A"}
                  </td>
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    {incident.title}
                  </td>
                  <td className="px-2 py-2 border-b bg-transparent">
                    <div className="relative w-[100px] h-5 bg-[#E5E7EB] rounded-full flex items-center">
                      <div
                        className="absolute h-full rounded-full"
                        style={{
                          width: `${incident.AverageEfficiencyLevel || 0}%`,
                          backgroundColor: getBarColor(incident.AverageEfficiencyLevel),
                        }}
                      />
                      <span className="relative text-white ml-2 text-xs">
                        {incident.AverageEfficiencyLevel !== null && incident.AverageEfficiencyLevel !== undefined
                          ? `${parseFloat(incident.AverageEfficiencyLevel).toFixed(0)}%`
                          : 'No Control'}
                      </span>
                    </div>
                  </td>
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    {incident.report_date
                      ? new Date(incident.report_date).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    <span className={`px-2 py-1 rounded-full text-xs ${incident.status === 'Open'
                      ? 'bg-red-100 text-red-800'
                      : incident.status === 'Closed'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                      }`}>
                      {incident.status}
                    </span>
                  </td>
                  <td className="px-2 py-2 border-b truncate whitespace-nowrap overflow-hidden bg-transparent">
                    {incident.status === "Closed" && incident.closed_at
                      ? new Date(incident.closed_at).toLocaleDateString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500">No incidents available.</p>
      )}

      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        contentStyle={{
          overflow: "auto",
          maxHeight: "80vh",
          width: "810px",
          marginTop: "10vh"
        }}
      >
        <IncidentDetailsForm
          closeIncident={closePopup}
          currentIncident={selectedIncident}
          not_editable={true}
        />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => {
  console.log("Incidnet List state", state)
  return {
    department_incidents: state.incident.incidents
  }
};

const mapDispatchToProps = (dispatch) => ({
  getDepartmentIncidents: (department_id) => dispatch(getDepartmentIncidents(department_id)),
  getIncidentsFN: (department_id) => dispatch(getIncidentsDepartment(department_id)),
  getIncidentsComplianceFN: (compliance_id) => dispatch(getIncidentsCompliance(compliance_id)),
  getIncidentFN: (incident_id) => dispatch(getIncident(incident_id)),
  closeOverlayFN:() => dispatch(closeOverlay()),
  closeIncidentFN:() => dispatch(closeIncident()),
  getRiskFN: (risk_id) => dispatch(getRisk(risk_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IncidentList);